import {
  START_LOADING,
  END_LOADING,
  FETCH_COMPANY_SETTINGS,
  UPDATE_COMPANY_SETTINGS,
} from "../actions/constants";

const initialState = {
  settings: null,
  isLoading: false,
  error: null
};

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_COMPANY_SETTINGS:
      return {
        ...state,
        settings: action.payload,
        isLoading: false
      };
    case UPDATE_COMPANY_SETTINGS:
      return {
        ...state,
        settings: action.payload,
        isLoading: false
      };
    default:
      return state;
  }
};

export default settingsReducer;
